export default __webpack_public_path__ + "static/media/currency.f6830857.svg";